"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormattedMessages = void 0;
var react_intl_1 = require("react-intl");
var useFormattedMessages = function (key, values) {
    if (values === void 0) { values = {}; }
    var intl = (0, react_intl_1.useIntl)();
    return Object.keys(intl.messages)
        .reduce(function (acc, currentKey) {
        var _a;
        return currentKey.startsWith(key) ? __assign(__assign({}, acc), (_a = {}, _a[currentKey.replace("".concat(key, "."), '')] = intl.formatMessage({
            id: currentKey,
        }, values, {
            ignoreTag: true,
        }), _a)) : acc;
    }, {});
};
exports.useFormattedMessages = useFormattedMessages;
exports.default = exports.useFormattedMessages;
